import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/components/Home';
import Roadmap from '@/components/Roadmap';
import Addon from '@/components/Addon';
import Upload from '@/components/Upload';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/roadmap',
      name: 'roadmap',
      component: Roadmap
    },
    {
      path: '/addon/:id',
      name: 'addon',
      component: Addon
    },
    {
      path: '/upload',
      name: 'upload',
      component: Upload
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js